import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Button from 'components/Button';
import Toast from 'components/Toast';
import Dialog from 'components/Dialog';
import URL from 'utils/URL';
import http from 'utils/http';
import API from 'utils/API';
import withI18n, { I18nProps } from 'utils/i18n/withI18n';
import './style.scss';

const Unsubscribe: React.FC<RouteComponentProps & I18nProps> = props => {
    const { i18n } = props;
    const { token } = URL.current().query;

    useEffect(() => {
        if (!token) {
            props.history.replace('/');
        }
    }, [props.history, token]);

    const handleUnsubscribe = async () => {
        Toast.loading(true);

        try {
            await http.get(API.EMAIL.unsubscribe(), {
                params: {
                    token
                }
            });

            Dialog.alert({
                content: i18n.__('You are now unsubscribed'),
                contentCentered: true
            }).then(() => {
                props.history.replace('/');
            });
        } catch (err) {
            Toast.show(err);
        }

        Toast.loading(false);
    };

    const handleCancel = () => {
        props.history.push('/');
    };

    return (
        <div className="unsubscribe-root">
            <div className="unsubscribe-content">
                <h5 className="unsubscribe-title">{i18n.__('WOULD YOU LIKE TO UNSUBSCRIBE FROM THESE EMAILS?')}</h5>
                <div className="unsubscribe-desc">
                    <h5>{i18n.__("YOU'LL STOP RECEIVING:")}</h5>
                    <ul className="unsubscribe-desc-list">
                        <li>{i18n.__('the latest info on new features')}</li>
                        <li>{i18n.__('limited-time offers')}</li>
                    </ul>
                </div>
                <div className="unsubscribe-button-list">
                    <Button className="unsubscribe-button" onClick={handleUnsubscribe}>
                        {i18n.__('UNSUBSCRIBE')}
                    </Button>
                    <Button type="light" className="unsubscribe-button" onClick={handleCancel}>
                        {i18n.__('CANCEL')}
                    </Button>
                </div>
                <div>
                    {i18n.__(
                        'Note: If you wish to receive our Marketing Mail again, please go to "Account Settings" to resubscribe.'
                    )}
                </div>
            </div>
        </div>
    );
};

export default withI18n(Unsubscribe);
